import React from 'react';

export const Wheel = ({carNumber, bogie, wheel, $uibModal}) => {

  const openSubsystemModal = () => {
    const subSystemObject = {
      name: bogie.name + bogie.ordinal,
      cis: wheel.ci_values,
      assets: [wheel],
      carNumber,
    };
    const modalInstance = $uibModal.open({
      component: 'subsystemModal',
      backdrop: 'static',
      windowClass: 'subSystemWindow',
      resolve: {
        subSystemObject: function () {
          return subSystemObject;
        },
      },
    });

    modalInstance.result.then(() => {}, () => {});
  };

  const wheelOrientation = () => {
    const isTop = wheel.ordinal <= 2;      // wheels 1,2 on top
    const isLeft = wheel.ordinal % 2 === 1; // wheels 1,3 on left
    
    const posY = isTop ? 'wheel-up' : 'wheel-bottom';
    const posX = isLeft ? 'wheel-left' : 'wheel-right';
    
    return `${posY} ${posX} ${wheel.status.toLowerCase()}`;
  };

  const wheelTitleOrientation = () => {
     const isTop = wheel.ordinal <= 2;
    if (isTop) {  // wheels 1,2 on top
      return 'title-wheel-up';
    } else {
      return 'title-wheel-bottom';
    }
  };

  return (
    <div className={"wheel " + wheelOrientation()} onClick={openSubsystemModal}>
      <div className={"wheel-textbox " + wheelTitleOrientation()}>
        <span className={"velocity-sensor-wheel fa-stack " + wheelTitleOrientation()}>
            {wheel.velocitySensorBroken && <>
              <i className="far fa-times-circle fa-stack-1x" title="Vibration sensor broken"/>
              <i className="fa-stack sensor-symbol">V</i>
            </>}
        </span>
        <span className="title-wheel">{wheel.ordinal}</span>
        <span className={"temperature-sensor-wheel fa-stack " + wheelTitleOrientation()}>
          {wheel.tempSensorBroken && <>
            <i className="far fa-times-circle fa-stack-1x" title="Temperature sensor broken"/>
            <i className="fa-stack sensor-symbol">T</i>
          </>}
        </span>
      </div>
    </div>
  )
};